// 子州肉羊

import Index from '../../views';

// 首页
const home = () => import('@/views/SmartLivestock-zzry/index/index.vue');
// 数据统计
const showData = () => import('@/views/SmartLivestock-zzry/statistics/showData.vue'); // 大数据展示
const showDataLevel = () => import('@/views/SmartLivestock-zzry/statisticsLevel/showData.vue'); // 大数据展示
const demonstrationDemo = () => import('@/views/SmartLivestock-zzry/statisticsLevel/demonstration.vue'); // 演示大屏
// const Industrial = () => import('@/views/SmartLivestock-zzry/statistics/Industrial.vue'); // 产业据展示
// 经营主体管理
const homeFarm = () => import('@/views/SmartLivestock-zzry/businessTheme/homeFarm.vue');
const artel = () => import('@/views/SmartLivestock-zzry/businessTheme/artel.vue');
const farmingEnterprises = () => import('@/views/SmartLivestock-zzry/businessTheme/farmingEnterprises.vue');
const trafficker = () => import('@/views/SmartLivestock-zzry/businessTheme/Trafficker.vue');
const slaughter = () => import('@/views/SmartLivestock-zzry/businessTheme/slaughter.vue');
const fodder = () => import('@/views/SmartLivestock-zzry/businessTheme/fodder.vue');
const vaccine = () => import('@/views/SmartLivestock-zzry/businessTheme/vaccine.vue');
// 实时监控管理
const padList = () => import('@/views/SmartLivestock-zzry/monitorManage/pdaList.vue'); // 设备列表

const aiStatistics = () => import('@/views/SmartLivestock-zzry/monitorManage/aiStatistics.vue'); // Ai算法统计
const xmds = () => import('@/views/SmartLivestock-zzry/monitorManage/xmds.vue'); // 小牧丁App下载
// 疫病防治管理
const preventionPersonnel = () => import('@/views/SmartLivestock-zzry/disease/preventionPersonnel.vue');
const vaccineRecords = () => import('@/views/SmartLivestock-zzry/disease/vaccineRecords.vue');
// 屠宰溯源管理
const slaughterHouseCurrent = () => import('@/views/SmartLivestock-zzry/slaughterHouse/current.vue');
const slaughterHouseList = () => import('@/views/SmartLivestock-zzry/slaughterHouse/list.vue');
// 技术服务
const technicalServices = () => import('@/views/SmartLivestock-zzry/technicalServices/technicalServices.vue'); // 专家管理
const liveTraining = () => import('@/views/SmartLivestock-zzry/technicalGuidance/liveTraining.vue'); // 直播培训
const coursewareVideo = () => import('@/views/SmartLivestock-zzry/technicalGuidance/coursewareVideo.vue'); // 课程管理
const videoManagement = () => import('@/views/SmartLivestock-zzry/technicalGuidance/videoManagement.vue'); // 视频视频id查询
const videoEdit = () => import('@/views/SmartLivestock-zzry/technicalGuidance/videoEdit.vue'); // 视频视频id查询
const serviceInformation = () => import('@/views/SmartLivestock-zzry/technicalGuidance/serviceInformation.vue'); // 草稿视频
// 系统设置
const organizational = () => import('@/views/peopleManage/organizational.vue'); // 机构管理
const personnel = () => import('@/views/peopleManage/personnel.vue'); // 人员管理
const role = () => import('@/views/peopleManage/role.vue');
// 畜牧平台系统设置
const organizationalzzry = () => import('@/views/SmartLivestock-zzry/peopleManage/organizational.vue'); // 机构管理
const personnelzzry = () => import('@/views/SmartLivestock-zzry/peopleManage/personnel.vue'); // 人员管理
const rolezzry = () => import('@/views/SmartLivestock-zzry/peopleManage/role.vue');

// 内容发布管理
const policy = () => import('@/views/SmartLivestock-zzry/contentRelease/policy.vue'); //内容管理
const stockMarket = () => import('@/views/SmartLivestock-zzry/contentRelease/stockMarket.vue');
const voice = () => import('@/views/SmartLivestock-zzry/contentRelease/voice.vue');

// 产业金融服务
const moneyToApply = () => import('@/views/SmartLivestock-zzry/financialService/moneyToApply.vue');
const livestockInsurance = () => import('@/views/SmartLivestock-zzry/financialService/livestockInsurance.vue');
const dataStatistics = () => import('@/views/SmartLivestock-zzry/financialService/dataStatistics.vue');
// 技术指导服务555
// 大数据中心
const bigData = () => import('@/views/SmartLivestock-zzry/datas/datas.vue');
const vr = () => import('@/views/SmartLivestock-zzry/vr/vr.vue');
// 物料管理
const info = () => import('@/views/SmartLivestock-zzry/material/info.vue');
const list = () => import('@/views/SmartLivestock-zzry/material/list.vue');
const out = () => import('@/views/SmartLivestock-zzry/material/out.vue');

// // 人员管理
// const organizational = () => import('@/views/peopleManage/organizational.vue');
// const personnel = () => import('@/views/peopleManage/personnel.vue');
// const role = () => import('@/views/peopleManage/role.vue');
// 系统设置
const systemSettings = () => import('@/views/SmartLivestock-zzry/systemSettings/index.vue');
const map = () => import('@/views/SmartLivestock-zzry/map/index.vue');
export default [
  {
    path: '/zzry',
    component: Index,
    children: [
      { path: '/', redirect: 'homeview' },
      { path: 'homeview', component: home, meta: { title: '首页' } },
      // 实时监控管理
      {
        path: '/zzry',
        component: { render: e => e('router-view') },
        children: [
          { path: 'padList', component: padList },
          { path: 'aiStatistics', component: aiStatistics },
          { path: 'xmds', component: xmds }
        ]
      },
      // 内容发布管理
      {
        path: '/zzry',
        component: { render: e => e('router-view') },
        children: [
          { path: 'policy', component: policy },
          { path: 'stockMarket', stockMarket },
          { path: 'voice', component: voice }
        ]
      },
      // 经营主体管理
      {
        path: '/zzry',
        component: { render: e => e('router-view') },
        children: [
          {
            path: 'homeFarm',
            component: homeFarm
          },
          {
            path: 'artel',
            component: artel
          },
          {
            path: 'farmingEnterprises',
            component: farmingEnterprises
          },
          {
            path: 'trafficker',
            component: trafficker
          },
          {
            path: 'slaughter',
            component: slaughter
          },
          {
            path: 'fodder',
            component: fodder
          },
          {
            path: 'vaccine',
            component: vaccine
          }
        ]
      },
      // 疫病防治管理
      {
        path: '/disease',
        component: { render: e => e('router-view') },
        children: [
          {
            path: 'preventionPersonnel',
            component: preventionPersonnel
          },
          {
            path: 'vaccineRecords',
            component: vaccineRecords
          }
        ]
      },
      // 屠宰溯源管理
      {
        path: '/zzry',
        component: { render: e => e('router-view') },
        children: [
          {
            path: 'slaughterHouseCurrent',
            component: slaughterHouseCurrent
          },
          {
            path: 'slaughterHouseList',
            component: slaughterHouseList
          }
        ]
      },
      // 技术服务
      // {
      //   path: '/zzry',
      //   component: { render: (e) => e('router-view') },
      //   children: [
      //     {
      //       path: 'technicalServices',
      //       component: technicalServices
      //     },
      //     {
      //       path: 'slaughterHouseList',
      //       component: slaughterHouseList
      //     }
      //   ]
      // },
      // 产业金融服务
      {
        path: '/financialService',
        component: { render: e => e('router-view') },
        children: [
          {
            path: 'moneyToApply',
            component: moneyToApply
          },
          {
            path: 'livestockInsurance',
            component: livestockInsurance
          },
          {
            path: 'dataStatistics',
            component: dataStatistics
          }
        ]
      },
      // 技术指导服务
      {
        path: '/zzry',
        component: { render: e => e('router-view') },
        children: [
          {
            path: 'technicalServices',
            component: technicalServices
          },
          {
            path: 'liveTraining',
            component: liveTraining
          },
          {
            path: 'coursewareVideo',
            component: coursewareVideo
          },
          {
            path: 'videoManagement',
            component: videoManagement
          },
          {
            path: 'videoEdit',
            component: videoEdit
          },
          {
            path: 'serviceInformation',
            component: serviceInformation
          }
        ]
      },
      // 大数据中心
      {
        path: '/datas',
        component: { render: e => e('router-view') },
        children: [
          {
            path: 'bigData',
            component: bigData
          },
          {
            path: 'vr',
            component: vr
          }
        ]
      },
      // 物料管理
      {
        path: '/zzry',
        component: { render: e => e('router-view') },
        children: [
          { path: 'info', component: info },
          { path: 'list', component: list },
          { path: 'out', component: out }
        ]
      },
      // 数据统计
      {
        path: '/zzry',
        component: { render: e => e('router-view') },
        children: [
          { path: 'showData', component: showData },
          // { path: 'Industrial', component: Industrial },
          { path: 'showDataLevel', component: showDataLevel },
          { path: 'demonstrationDemo', component: demonstrationDemo } // 演示大屏
        ]
      },
      // 人员管理
      {
        path: '/zzry',
        component: { render: e => e('router-view') },
        children: [
          { path: 'organizational', component: organizationalzzry },
          { path: 'personnel', component: personnelzzry },
          { path: 'role', component: rolezzry }
        ]
      },
      // 系统设置
      {
        path: '/system',
        component: { render: e => e('router-view') },
        children: [
          {
            path: 'systemSetting',
            component: systemSettings
          }
        ]
      },
      // 地图设置
      {
        path: '/map',
        component: map
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/zzry/index.js